import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';

import { BaseText, ButtonTertiary } from '@warrenbrasil/nebraska-web';
import { PlannedChart, PlannedTable } from './components';
import { AllocationLoader } from '@/modules/wealth/components/AllocationLoader';

import {
  getPlannedAllocation,
  IPlannedAllocation
} from '@/modules/wealth/services/portfolio-allocation';

interface Props {
  portfolioId: string;
  hasApplied: boolean;
  isCustom: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PlannedAllocation',
  props: {
    portfolioId: null,
    hasApplied: { type: Boolean },
    isCustom: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  portfolioId: string;
  hasApplied: boolean;
  isCustom: boolean;
};



const plannedAllocation = ref<IPlannedAllocation>();
const isLoading = ref(true);
const hasError = ref(false);

const plannedChart = computed(() => {
  return plannedAllocation.value!.chart;
});

const plannedTable = computed(() => {
  return plannedAllocation.value!.items;
});

async function fetchPlannedAllocation() {
  hasError.value = false;
  isLoading.value = true;

  try {
    const params = {
      hasApplied: props.hasApplied
    };
    plannedAllocation.value = await getPlannedAllocation(
      props.portfolioId,
      params
    );
  } catch {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

onMounted(() => {
  !props.isCustom && fetchPlannedAllocation();
});

return { __sfc: true,props, plannedAllocation, isLoading, hasError, plannedChart, plannedTable, fetchPlannedAllocation, BaseText, ButtonTertiary, PlannedChart, PlannedTable, AllocationLoader }
}

})